export enum EApplicationType {
  RESIDENTIAL = "RESIDENTIAL",
  INSTITUTIONS = "INSTITUTIONS",
  HOTELS = "HOTELS",
  HOSTELS = "HOSTELS",
  SCHOOLS = "SCHOOLS",
}
